import clsx from "clsx";
import { Spinner } from "react-bootstrap";
import { React } from "react";
const classes = (minHeight) => ({
  height: {
    "min-height": minHeight,
  },
});
function LoadingOverlay({ loading = false, loadingClass = null, isSemiLoading = false }) {
  return loading ? (
    isSemiLoading ? (
      <Spinner className={clsx("semi-loading")} animation="border" variant="secondary" size="sm"></Spinner>
    ) : (
      <div
        className={clsx("loading-container", {
          "loading-effect": loading,
          [loadingClass]: loadingClass !== null,
        })}
      >
        <div className={clsx("loading-spinner")}>
          <Spinner animation="border" variant="primary" size="md">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <span className={clsx("mt-2")}>Loading...</span>
        </div>
      </div>
    )
  ) : (
    false
  );
}

export default LoadingOverlay;
